import React, { useMemo } from "react";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Chip,
    useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import HeadComponent from "../list/list-head/Head.component";

const AmbientTable = ({ item }) => {
    const { t } = useTranslation();
    const theme = useTheme()

    const TABLE_HEAD = useMemo(
        () => [
            {
                id: "envMonitoring",
                label: t("environmental monitoring"),
                alignRight: false,
                order: true
            },
            {
                id: "envMonitoringType",
                label: t("type"),
                alignRight: false,
                order: true
            },
        ],
        [t]
    );

    return (
        <TableContainer>
            <Table size="small" aria-label="purchases">
                <HeadComponent header={TABLE_HEAD} sx={{ fontSize: 12 }} />

                <TableBody>
                    <TableRow
                        sx={{
                            "&:last-child td, &:last-child th": {
                                border: 0,
                            },
                        }}
                    >
                        <TableCell align="left">
                            {item?.envMonitoring ? (
                                <Chip
                                    label={t('Present')}
                                    size='small'
                                    sx={{
                                        backgroundColor: "#B9F6CA",
                                        color: "#00C853",
                                    }}
                                />
                            ) : (
                                <Chip label={t('absent')} size='small' />
                            )}

                        </TableCell>

                        {item?.envMonitoringType && (
                            <TableCell align="left">
                                {item?.envMonitoringType === "base" ? (
                                    <Chip
                                        label={t('base')}
                                        size="small"
                                        sx={{
                                            backgroundColor: theme.palette.primary.light,
                                            color: theme.palette.primary.main,
                                        }}
                                    />
                                ) : (
                                    <Chip
                                        label={t('advanced')}

                                        size="small"
                                        sx={{
                                            backgroundColor: theme.palette.primary.light,
                                            color: theme.palette.primary.main,
                                        }}
                                    />
                                )}
                            </TableCell>
                        )}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AmbientTable;
